import {AppUser, AppState} from "../models/app";
// @ts-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import omit from "lodash/omit";
import {DeviceInfo} from "@capacitor/device";
import {ProdutoObject} from "../models/Produto";
import localForage from "localforage";


const initialState: AppState = {
  loggedIn: false,
  user: {
    uid: '',
    email: '',
    hasProfile: false,
    profileComplete: false,
    loaded: false,
  },
  notification: {
    visible: false,
    duration: 6000,
    color: 'dark',
    message: '',
  },
  reloadProfile: false,
  jumpHistory: [],
  online: false,
  frAccessAuthorized: false,
  deviceInfo: undefined,
  cacheData: {
    produtos: [],
    produtosBiologicos: [],
    eventosTipos: {},
  }
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    login: (state: AppState, action: PayloadAction<AppUser>) => {
      return {
        ...state,
        user: action.payload,
        loggedIn: true,
      };
    },

    logout: (state: AppState) => {
      return {
        ...state,
        loggedIn: false,
        frAccessAuthorized: false,
      };
    },

    // TODO: extrair para outro slice
    notify: (state: AppState, action: PayloadAction<string>) => {
      return {
        ...state,
        notification: {
          ...state.notification,
          visible: true,
          color: 'dark',
          message: action.payload,
        },
      }
    },

    notifySuccess: (state: AppState, action: PayloadAction<string>) => {
      return {
        ...state,
        notification: {
          ...state.notification,
          visible: true,
          color: 'success',
          message: action.payload,
        },
      }
    },

    notifyError: (state: AppState, action: PayloadAction<string>) => {
      return {
        ...state,
        notification: {
          ...state.notification,
          visible: true,
          color: 'danger',
          message: action.payload,
        },
      }
    },

    notifyDismiss: (state: AppState) => {
      return {
        ...state,
        notification: {
          ...state.notification,
          visible: false,
          message: '',
          color: 'dark',
        },
      }
    },

    setOnline: (state: AppState, action: PayloadAction<boolean>) => {
      return {
        ...state,
        online: action.payload,
      }
    },

    setFrAccessAuthorized: (state: AppState, action: PayloadAction<boolean>) => {
      return {
        ...state,
        frAccessAuthorized: action.payload,
      }
    },

    reloadProfile: (state: AppState) => {
      return {
        ...state,
        reloadProfile: true,
      };
    },

    reloadProfileDone: (state: AppState) => {
      return {
        ...state,
        reloadProfile: false,
      };
    },

    jump: (state:any, action: PayloadAction<string>) => {
      const jumpHistory = [...state.jumpHistory, action.payload];
      return {
        ...state,
        jumpHistory,
      };
    },

    setJumpHistory: (state:any, action: PayloadAction<string[]>) => {
      return {
        ...state,
        jumpHistory: action.payload,
      };
    },

    setDeviceInfo: (state:any, action: PayloadAction<DeviceInfo>) => {
      return {
        ...state,
        deviceInfo: action.payload,
      };
    },

    setProdutos: (state:any, action: PayloadAction<ProdutoObject[]>) => {
      return {
        ...state,
        cacheData: {
          ...state.cacheData,
          produtos: action.payload,
        },
      };
    },
  },
});


export const actions = {
  login: (user: AppUser) => {
    // filtrar dados nao serializaveis
    return {
      type: 'app/login',
      payload: omit(user, ['ultimo_acesso', 'criado_em', 'atualizado_em']),
    }
  },
  logout: () => {
    return {
      type: 'app/logout',
    }
  },
  notifySuccess: (message: string) => {
    return {
      type: 'app/notifySuccess',
      payload: message,
    }
  },
  notifyError: (message: string) => {
    return {
      type: 'app/notifyError',
      payload: message,
    }
  },
  notifyDismiss: () => {
    return {
      type: 'app/notifyDismiss',
    }
  },
  setOnline: (online: boolean) => {
    return {
      type: 'app/setOnline',
      payload: online,
    }
  },
  setFrAccessAuthorized: (frAccessAuthorized: boolean) => {
    return {
      type: 'app/setFrAccessAuthorized',
      payload: frAccessAuthorized,
    }
  },
  reloadProfile: () => {
    return {
      type: 'app/reloadProfile',
    }
  },
  reloadProfileDone: () => {
    return {
      type: 'app/reloadProfileDone',
    }
  },
  jump: (location: string) => {
    return {
      type: 'app/jump',
      payload: location,
    }
  },
  setJumpHistory: (jumpHistory: string[]) => {
    return {
      type: 'app/setJumpHistory',
      payload: jumpHistory,
    }
  },
  setDeviceInfo: (deviceInfo: DeviceInfo) => {
    return {
      type: 'app/setDeviceInfo',
      payload: deviceInfo,
    }
  },
  setProdutos: (produtos: ProdutoObject[]) => {
    return {
      type: 'app/setProdutos',
      payload: produtos,
    }
  },
};

export const resetLocalStorage = async () => {
  // preservar apenas fcmToken
  const fcmToken = await localForage.getItem<string>('fcmToken');
  await localForage.clear();
  await localForage.setItem('fcmToken', fcmToken);
}
